import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { ReactElement } from 'react';
import { useLocalization } from '@ais-ui/locale-management';
import { PiMagicWand, PiCopy } from 'react-icons/pi';
import { useCreateReportContext } from './CreateReportContext';

interface CreateModeSelectionProps {
  wizardContent: ReactElement;
  cloneContent: ReactElement;
}

export const CreateModeSelection = ({
  wizardContent,
  cloneContent,
}: CreateModeSelectionProps) => {
  const { messages } = useLocalization();
  const { activeTab, setActiveTab } = useCreateReportContext();

  const handleTabChange = (value: string) => {
    setActiveTab(value as 'wizard' | 'quick');
    // Focus the template name input after tab switch
    setTimeout(() => {
      const input = document.getElementById('report-template-name');
      if (input) {
        (input as HTMLInputElement).focus();
      }
    }, 50);
  };

  return (
    <Tabs
      value={activeTab}
      onValueChange={handleTabChange}
      className="w-full h-full flex flex-col"
    >
      <TabsList className="grid w-full grid-cols-2 mb-6 flex-shrink-0">
        <Tooltip>
          <TabsTrigger asChild value="wizard">
            <TooltipTrigger className="flex items-center gap-2">
              <PiMagicWand className="size-4" />
              Wizard
            </TooltipTrigger>
          </TabsTrigger>
          <TooltipContent>Guided step-by-step report creation</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TabsTrigger asChild value="quick">
            <TooltipTrigger className="flex items-center gap-2">
              <PiCopy className="size-4" />
              Quick
            </TooltipTrigger>
          </TabsTrigger>
          <TooltipContent>
            Quick report creation for experienced users
          </TooltipContent>
        </Tooltip>
      </TabsList>

      <TabsContent value="wizard" className="flex-1 min-h-0 overflow-hidden">
        {wizardContent}
      </TabsContent>

      <TabsContent value="quick" className="flex-1 min-h-0 overflow-hidden">
        {cloneContent}
      </TabsContent>
    </Tabs>
  );
};
